import React from "react";
import { Link } from "react-router-dom";

import "./UniverseShowcase.scss";

export const UniverseShowcase = ({
  images,
  viewAllPath = "/universe",
}) => {
  return (
    <section className="universe-showcase">

      <div className="universe-showcase-inner">

        <div className="universe-topbar">
          <div>
            <span>05</span>
            <small>LHANGAR UNIVERSE</small>
          </div>

          <Link to={viewAllPath}>
            EXPLORE ALL <span>↗</span>
          </Link>
        </div>

        <div className="universe-heading">

          <h2>
            BUILT BEYOND
            <span>THE MUSIC.</span>
          </h2>

          <p>
            LHANGAR lives beyond the cypher.
            Objects, clothing, environments and
            visual systems are designed as part of
            one connected creative universe.
          </p>

        </div>

        <div className="universe-editorial">

          <article className="universe-feature">

            <img
              src={images[0]}
              alt="LHANGAR universe"
            />

            <div className="universe-card-overlay">
              <small>01 / OBJECT</small>

              <h3>
                THE ICONIC
                <span>LHANGAR CAN.</span>
              </h3>
            </div>

          </article>

          <div className="universe-stack">

            {images.slice(1, 3).map(
              (image, index) => (
                <article
                  className="universe-small-card"
                  key={index}
                >
                  <img
                    src={image}
                    alt={`LHANGAR universe ${
                      index + 2
                    }`}
                  />

                  <span>
                    0{index + 2}
                  </span>
                </article>
              )
            )}

          </div>

        </div>

        <div className="universe-bottom-row">

          {images.slice(3).map(
            (image, index) => (
              <article
                className="universe-bottom-card"
                key={index}
              >
                <img
                  src={image}
                  alt={`LHANGAR visual ${
                    index + 4
                  }`}
                />

                <div>
                  <span>
                    0{index + 4}
                  </span>

                  <small>
                    CREATIVE UNIVERSE
                  </small>
                </div>
              </article>
            )
          )}

        </div>

      </div>

    </section>
  );
};